import PdfPageBase from "./../../../common/components/pdfPageBase";

export default class PdfPage extends PdfPageBase {
  panning = false;
  toShow = false;
  shown = false;
  /** @type {PDFPageView | null} */
  pdfPageView = null;
  /** @type {number} */
  zoomForNextRender = 0;

  async _cleanup() {
    super._cleanup();
    if (this.pdfPageView) {
      this.pdfPageView.destroy();
      this.pdfPageView = null;
    }
    const pageSelector = this.pdfPage.querySelector(".page");
    if (pageSelector) {
      this.pdfPage.removeChild(pageSelector);
    }
  }

  hideOrShow() {
    if (this.shown && !this.toShow) {
      //hide
      this.shown = false;
      this.pdfPage.classList.add("hidden");
    } else if (this.shown && this.panning) {
      //hide because panning
      this.shown = false;
      this.pdfPage.classList.add("hidden");
    } else if (!this.shown && !this.panning && this.toShow) {
      //show
      this.shown = true;
      this.pdfPage.classList.remove("hidden");
    }
  }

  pdfPan(panning) {
    this.panning = panning;
    this.hideOrShow();
  }

  stopRenderTask() {
    this.cancelRender = true;
  }

  /**
   * Hides the pdf part
   */
  hidePdf() {
    if (this.pdfPage) {
      this.stopRenderTask();
    }
  }

  _update(zoom) {
    this.toShow = false;
    this.hideOrShow();
    const now = Date.now();
    this.lastRequestedZoom = zoom;
    this.lastRequestedZoomTime = now;
    let event;
    clearTimeout(event);
    event = setTimeout(() => {
      if (
        this.lastRequestedZoom === zoom &&
        this.lastRequestedZoomTime === now
      ) {
        if (!this.renderTask) {
          this._render(zoom);
        } else {
          this.zoomForNextRender = zoom;
        }
      }
    }, 200);
  }

  _createPdfPageView(zoom) {
    this.pdfPageView = new PDFJS.PDFPageView({
      container: this.pdfPage,
      id: 1,
      scale: zoom,
      defaultViewport: this.pdf.getViewport(zoom),
    });
    this.pdfPageView.setPdfPage(this.pdf);
    this.pdfPage.classList.add("hidden");
  }

  async _render(zoom) {
    this.renderTask = true;
    this.pdfPageView.update(zoom);
    if (this.zoomInProgress === zoom) {
      return;
    }
    this.zoomInProgress = zoom;
    this.lastRendered = 0;
    await this.pdfPageView.draw();
    try {
      if (this.cancelRender) {
        if (this.zoomForNextRender) {
          if (this.zoomForNextRender === zoom) {
            this.lastRendered = zoom;
            this.renderTask = false;
            this.zoomForNextRender = 0;
            this.zoomInProgress = 0;
            this.toShow = true;
            this.hideOrShow();
          } else {
            this._render(this.zoomForNextRender);
          }
        } else {
          this.lastRendered = 0;
          this.renderTask = false;
          this.zoomInProgress = 0;
        }
      } else {
        this.lastRendered = zoom;
        this.renderTask = false;
        this.zoomForNextRender = 0;
        this.zoomInProgress = 0;
        this.toShow = true;
        this.hideOrShow();
      }
    } catch (error) {
      this.renderTask = false;
    }
  }

  async renderPdf() {
    if (this.pdfPage) {
      if (this.shouldRenderPdf()) {
        this.cancelRender = false;
        await this.prefetchPDF();
        try {
          if (!this.cancelRender && this.pdf) {
            let zoom = this.getZoomScale(this.pdf);
            if (!this.pdfPageView) {
              this._createPdfPageView(zoom);
              this._render(zoom);
            } else {
              this._update(zoom);
            }
          }
        } catch (error) {
          console.log(error); //eslint-disable-line
        }
      } else {
        this.toShow = false;
        this.hideOrShow();
      }
    }
  }

  shouldRenderPdf() {
    if (this.appState.inFullScreenMode && this.appState.zoomScale > 1)
      return true;
    if (
      this.DOMContainer.clientWidth > this.options.pdfThreshold.width ||
      this.DOMContainer.clientHeight > this.options.pdfThreshold.height
    ) {
      return true;
    }
    return false;
  }

  async _loadPdfJs() {
    const promise = new Promise((resolve) => {
      require.ensure(
        [],
        (require) => {
          require("pdfjs-dist/web/pdf_viewer"); //eslint-disable-line
          PDFJS.workerSrc = require("file-loader!pdfjs-dist/build/pdf.worker.min.js"); //eslint-disable-line
          resolve();
        },
        "pdf"
      );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/pdfPageComponent.js